export default __webpack_public_path__ + "static/image/linkedin.ec1ac4b8.png";